import { useAsyncValue } from "react-router-dom"
import { HistoryItem } from "./history-item";


export const Completed = () => {
    const data = useAsyncValue();

    return <HistoryItem data={data}/>;
}